import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[fallbackImage]'
})
export class FallbackImageDirective implements OnInit {
  @Input() fallbackImage: string = 'assets/images/image-placeholder.jpg';
  
  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    const img = new Image();
    const element = this.elementRef.nativeElement;
    const url = element.style.backgroundImage.slice(4, -1).replace(/"/g, "");

    img.onerror = () => {
      element.style.backgroundImage = `url('assets/images/image-placeholder.jpg')`;
    };

    img.src = url;
  }
}